<ion-app [class.mobile-shell]="isMobileShell">
  <ion-menu contentId="main-content" type="overlay">
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title class="menu-logo-title">
          <img
            src="assets/images/logo.png"
            alt="Safarizine - Safari and Nature Experience"
            class="menu-logo-img ion-padding-horizontal" />
        </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list lines="none">
        <ion-menu-toggle auto-hide="false" *ngFor="let p of pages">
          <ion-item
            [routerLink]="p.url"
            routerDirection="root"
            routerLinkActive="active-item"
            detail="false">
            <ion-icon [name]="p.icon" slot="start"></ion-icon>
            <ion-label>{{ p.title }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>

  <ion-footer *ngIf="isMobileShell" class="mobile-app-footer">
    <div class="mobile-demo-notice" role="note">
      <span>
        {{ (settings$ | async)?.highlight_notes || defaultHighlightNotes }}
      </span>
    </div>

    <ion-tab-bar color="light" slot="bottom">
      <ion-tab-button
      *ngFor="let tab of mobileTabs"
      [routerLink]="tab.url"
      routerLinkActive="active-tab">
        <ion-icon [name]="tab.icon"></ion-icon>
        <ion-text>{{ tab.title }}</ion-text>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-footer>
</ion-app>
